/*
 * Defines default handling of error response codes
 */
;(function () {
  angular
    .module('contrast.auth')
    .factory('securityInterceptor', securityInterceptor)

  function securityInterceptor(
    $q,
    $location,
    $rootScope,
    $routeParams,
    URLHistoryService,
    AUTH_EVENTS,
    SERVER_MESSAGES
  ) {
    'ngInject'

    return {
      responseError: handleErrorResponse
    }

    function redirectToSignInPage(isLoginPage, response) {
      if (!isLoginPage) {
        if (
          $routeParams.orgUuid ||
          // Can hit this url while not authorized, will be instructed to sign in
          $location.path().includes('scm-onboarding')
        ) {
          URLHistoryService.setPreviousUrl($location.url())
        }
        $rootScope.$broadcast(AUTH_EVENTS.UNAUTHENTICATED_EVENT)
        if (
          response.config &&
          response.config.url == '/Contrast/api/ng/profile/password/validate'
        ) {
          $location.replace().path('/pages/signin').search('locked', 'true')
        } else {
          $location
            .replace()
            .path('/pages/signin', true)
            .search('unauthenticated', 'true')
        }
      }
    }

    function handleErrorResponse(response) {
      var isLoginPage = $location.path() == '/pages/signin'

      switch (response.status) {
        case 301:
          if (!isLoginPage) {
            $location.replace().path('/pages/expired-password')
          }
          break

        case 303:
          if (!isLoginPage && $location.path() !== '/tsv/verification') {
            $location.replace().path('/tsv/verification')
          }
          break

        case 307:
          if (!isLoginPage && $location.path() !== '/tsv/setup') {
            $location.replace().path('/tsv/setup')
          }
          break

        case 401:
          redirectToSignInPage(isLoginPage, response)
          break

        case 403:
          // For CSRF token problem go back to login
          if (
            response &&
            response.data &&
            Array.isArray(response.data.messages) &&
            response.data.messages.includes(SERVER_MESSAGES.CSRF_ERROR)
          ) {
            if (!isLoginPage) {
              $rootScope.$broadcast(AUTH_EVENTS.TRIGGER_LOGOUT)
              redirectToSignInPage(isLoginPage, response)
            }
          } else if (!isLoginPage) {
            $rootScope.$broadcast('roles:updated')
            $location.replace().path('/pages/403')
          }
          break

        case 412:
          $location.replace().path('/pages/expired')
          break

        case 503:
          $location.replace().path('/pages/503')
          break

        default:
          break
      }

      return $q.reject(response)
    }
  }
})()
